import React from 'react';
import {
    Input,
    Icon,
    Col, Row,
    Table,
    Pagination,
    Button,
    Form,
    Tooltip,
    Select,
    Modal,

} from 'antd';
import styles from './index.less';
import { formatMessage } from '../localintl';

const SelectOption=Select.Option;

const {Search} = Input;
import AsyncAppHOCFN  from '../AsyncAppHOC'
import {getLocale } from '../localintl';

const FormItem=Form.Item;
import style from './index.less'
import {getOptionsByDictionary,changeByDictionary} from '../utils/common';
const formItemLayout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
};
import IntlWrap from '../intlWrap'
class System extends React.Component {


    constructor(props) {
        super(props);
        this.state={
            value:props.system,
            defalutValue:'',
            dataArray:[]
        }
    }



    /**
     * 组件渲染之后执行
     */
    componentDidMount() {
        this.dispatchRequet()
    }

    dispatchRequet=()=>{
        const {dispatch,getDate,locale,system} = this.props;
        getDate(
            {
                name:'getSystemDate',
                url:'http://192.168.3.80:10201/api/101115101',
                locale
            },()=>{

                let {getSystemDate}=this.props;
                console.log(getSystemDate,'getCurrencyDate');
                let rows=getSystemDate.posts&&getSystemDate.posts.rows||[];
                let defalutValue=''
                rows.map(r=>{
                    console.log(r.functionLanguage,system,'systemsystemsystemsystem')
                    if(r.functionLanguage&&system&&r.functionLanguage.toLocaleLowerCase()==system.toLocaleLowerCase()){
                        defalutValue= r.routePath
                    }
                })
                console.log(defalutValue,'defalutValue');
                this.setState({
                    defalutValue,
                    dataArray:rows
                })
                // this.setState({
                //     currency:rows
                // });
            })
    }
    handleChange=(value)=>{

        // this.props.history.push({pathname:value})
        let accessToken=localStorage.getItem('accessToken');
        window.location.href=value+'?accessToken='+accessToken
    }
    render(){
        let {dataArray,defalutValue,}=this.state;
        let {disabled=false}=this.props;
        let selectedLang = getLocale();
        return(
            <Select value={defalutValue}  dropdownClassName={'menujump'} className={styles.select} onChange={this.handleChange}>
                {
                    dataArray.map(r=>{
                        return <SelectOption value={r.routePath} key={r.routePath}> {formatMessage({id:'System.'+r.functionLanguage})}</SelectOption>
                    })
                }


            </Select>
        )
    }
}


export default IntlWrap(AsyncAppHOCFN(System));